var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.35 58.7188H13.65C9.0375 58.7188 5.28125 54.9687 5.28125 50.35V13.5875C5.28125 9.00625 9.00625 5.28125 13.5875 5.28125H31.0938V9.03125H13.5875C11.075 9.03125 9.03125 11.075 9.03125 13.5875V50.3563C9.03125 52.9 11.1 54.975 13.65 54.975H50.3563C52.9 54.975 54.975 52.9063 54.975 50.3563V32.9062H58.725V50.35C58.7187 54.9687 54.9687 58.7188 50.35 58.7188Z",
    fill: "#4B4B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6875 20.9375H54.9375V9.0625H43.0625V5.3125H58.6875V20.9375Z",
    fill: "#4B4B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5176 5.82617L58.1688 8.47742L33.3796 33.2666L30.7284 30.6154L55.5176 5.82617Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLinkIcon);
export default __webpack_public_path__ + "static/media/Open_Link_Icon.33c01af009554bad4d3b93f35d2f302e.svg";
export { ForwardRef as ReactComponent };